var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import { useLabels } from '@core-front/label-provider';
const isSuggestionField = (props) => {
    return Object.prototype.hasOwnProperty.call(props, 'items');
};
const BEM = (props) => {
    const classArray = ['search'];
    if (props.hideLabel) {
        classArray.push('search--no-label-' + props.hideLabel);
    }
    if (props.size) {
        classArray.push('search--' + props.size);
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
};
const SearchCore = (props) => {
    return (React.createElement(AnalyticsTrigger, { trigger: {
            callback: 'onSubmit',
            id: `Search - Submit - ${props.id}`,
            elementType: 'search',
            interactionType: 'submit',
            elementId: props.id,
        } },
        React.createElement(SearchCoreInner, Object.assign({}, props))));
};
const SearchCoreInner = (props) => {
    const { components, formAttributes, searchRef, onSubmit, isDisabled, placeholder, label, inputRef, isClearable = true, focusOnMount, submitButtonText } = props, rest = __rest(props, ["components", "formAttributes", "searchRef", "onSubmit", "isDisabled", "placeholder", "label", "inputRef", "isClearable", "focusOnMount", "submitButtonText"]);
    const { Icon, SuggestionField, TextField } = components;
    const input = React.useRef(null);
    const labels = useLabels();
    const setInputRef = (el) => {
        input.current = el;
        if (inputRef) {
            inputRef(el);
        }
    };
    const renderInput = () => {
        const inputProps = Object.assign(Object.assign({}, rest), { className: 'search__textfield', inputClass: 'search__input', inputRef: setInputRef, isClearable, label: placeholder || label, isDisabled });
        return isSuggestionField(props) ? React.createElement(SuggestionField, Object.assign({}, inputProps)) : React.createElement(TextField, Object.assign({}, inputProps));
    };
    React.useEffect(() => {
        if (focusOnMount && input.current) {
            input.current.focus();
        }
    }, [focusOnMount]);
    return (React.createElement("form", Object.assign({}, formAttributes, { className: BEM(props), ref: searchRef, onSubmit: onSubmit }),
        renderInput(),
        React.createElement("button", { className: "search__action", type: "submit", disabled: isDisabled },
            React.createElement("span", { className: "sr-only" }, submitButtonText || labels.get('search.submit')),
            React.createElement(Icon, { modifiers: "#search", className: "search__action-icon" }))));
};
export { SearchCore as default };
